import React, { useState, useEffect } from 'react'
import { createUseStyles } from 'react-jss'
import { useInView } from 'react-intersection-observer'
import CountUp from 'react-countup'
import { colors } from '../../../theme/palette'
import { Typography } from '../Typography/Typography'

interface PercentCircleProps {
    size: number
    strokeWidth: number
    percentage: number
}

const useStyles = createUseStyles({
    container: {
        position: 'relative',
        backgroundColor: colors.green500,
        borderRadius: '.5rem',
        display: 'flex',
        height: 'fit-content',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
    },
    svgContainer: {
        padding: '2rem',
    },
    text: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: colors.white,
    },
    percentage: {
        fontWeight: 700,
    },
})

const PercentCircle: React.FC<PercentCircleProps> = ({
    size,
    strokeWidth,
    percentage,
}) => {
    const classes = useStyles()
    const [progress, setProgress] = useState(0)
    const { ref, inView } = useInView()

    useEffect(() => {
        if (inView) {
            setProgress(percentage)
        } else {
            setProgress(0)
        }
    }, [inView, percentage])

    const viewBox = `0 0 ${size} ${size}`
    const radius = (size - strokeWidth) / 2
    const circumference = radius * Math.PI * 2
    const dash = (progress * circumference) / 100

    return (
        <div className={classes.container} ref={ref}>
            <div className={classes.svgContainer}>
                <svg width={size} height={size} viewBox={viewBox}>
                    <circle
                        fill="none"
                        stroke="white"
                        strokeOpacity="0.100497"
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        strokeWidth={`${strokeWidth}px`}
                    />
                    <circle
                        fill="none"
                        stroke="white"
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        strokeWidth={`${strokeWidth}px`}
                        transform={`rotate(-90 ${size / 2} ${size / 2})`}
                        strokeDasharray={String([dash, circumference - dash])}
                        strokeLinecap="round"
                        style={{ transition: 'all 0.5s' }}
                    />
                </svg>
                <div className={classes.text}>
                    <Typography
                        tag="h3"
                        size="XXXL"
                        spacing=".2rem"
                        color="white"
                        weight="bold"
                    >
                        {inView && (
                            <>
                                <CountUp
                                    end={percentage}
                                    start={0}
                                    duration={0.5}
                                />
                                <span>%</span>
                            </>
                        )}
                    </Typography>
                </div>
            </div>
            {/* <Typography tag="h3" size="S" spacing=".2rem" color="white">
                <span className={classes.percentage}>
                    {inView && (
                        <>
                            <CountUp
                                end={percentage}
                                start={0}
                                duration={0.5}
                            />
                            <span>%</span>
                        </>
                    )}
                </span>{' '}
                af dine kollegaer er organiseret
            </Typography> */}
        </div>
    )
}

export { PercentCircle }
